import verificationTypes from './verification.types';

/** ***************** SEND AADHAR OTP START *********************** */
export const sendAadharOtpStart = (addData: any) => ({
	type: verificationTypes.SEND_AADHAR_OTP_START,
	payload: addData,
});

export const sendAadharOtpSuccess = (successData: any) => ({
	type: verificationTypes.SEND_AADHAR_OTP_SUCCESS,
	payload: successData,
});

export const sendAadharOtpFailure = (failureData: any) => ({
	type: verificationTypes.SEND_AADHAR_OTP_FAILURE,
	payload: failureData,
});

export const sendAadharOtpResponseResetStart = () => ({
	type: verificationTypes.SEND_AADHAR_OTP_RESPONSE_RESET_START,
});

export const sendAadharOtpResponseResetChanged = () => ({
	type: verificationTypes.SEND_AADHAR_OTP_RESPONSE_CHANGED,
});

/** ***************** AADHAR OTP VERIFY START *********************** */
export const aadharOtpVerifyStart = (addData: any) => ({
	type: verificationTypes.AADHAR_OTP_VERIFY_START,
	payload: addData,
});

export const aadharOtpVerifySuccess = (successData: any) => ({
	type: verificationTypes.AADHAR_OTP_VERIFY_SUCCESS,
	payload: successData,
});

export const aadharOtpVerifyFailure = (failureData: any) => ({
	type: verificationTypes.AADHAR_OTP_VERIFY_FAILURE,
	payload: failureData,
});

export const aadharOtpVerifyResponseResetStart = () => ({
	type: verificationTypes.AADHAR_OTP_VERIFY_RESPONSE_RESET_START,
});

export const aadharOtpVerifyResponseResetChanged = () => ({
	type: verificationTypes.AADHAR_OTP_VERIFY_RESPONSE_CHANGED,
});
/** ***************** AADHAR OTP VERIFY END *********************** */
